// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2kGt7","subheader":"ReorderModal_subheader__3TUg9","listWrap":"ReorderModal_listWrap__1-g4d"};